import { DialogConfirmation } from '@reapitform/common-ui'
import React from 'react'

interface IWarningUnsavedChanges {
  isOpen?: boolean
  onClose?: () => void
  onContinue?: () => void
}

export const WarningUnsavedChangesModal: React.FC<IWarningUnsavedChanges> = ({
  isOpen = false,
  onClose,
  onContinue,
}) => {
  return (
    <DialogConfirmation
      message="You have unsaved changes in another section. Continuing will discard these changes. Do you want to proceed?"
      title="Unsaved Changes"
      isOpen={isOpen}
      onCancel={() => onClose?.()}
      onClose={() => onClose?.()}
      onConfirm={() => onContinue?.()}
      confirmButtonText="Discard & Proceed"
      intent="danger"
    />
  )
}
